import { TypedDocumentNode, gql } from '@apollo/client';
import { FormattedMessage, FormattedNumber } from 'react-intl';

import {
  GameStatus,
  ScoreStatus,
} from '@sorare/core/src/__generated__/globalTypes';
import { BodyS } from '@sorare/core/src/atoms/typography';
import { playerGameStatusLabels } from '@sorare/core/src/lib/glossary';
import { withFragments } from '@sorare/core/src/lib/gql';

import { GenericGame } from 'components/seo/Games/Game';
import { anyGameToGenericGame } from 'lib/anyGame';

import type { anyPlayerGameStatsToGenericGame_anyPlayerGameStats } from './__generated__/anyPlayerGameStats.graphql';

export const anyPlayerGameStatsToGenericGame = withFragments(
  ({
    playerGameStats,
    onClick,
  }: {
    playerGameStats: anyPlayerGameStatsToGenericGame_anyPlayerGameStats;
    onClick?: (id: string) => void;
  }): GenericGame => {
    const { anyGame, playerGameScore } = playerGameStats;
    const matchLiveOrPlayed = [
      GameStatus.played,
      GameStatus.playing,
    ].includesValue(anyGame.statusTyped);

    const computedGameScore = playerGameScore;

    const isDnp = [ScoreStatus.DID_NOT_PLAY, ScoreStatus.NO_GAME].includesValue(
      computedGameScore?.scoreStatus
    );
    return {
      ...anyGameToGenericGame({ anyGame }),
      ...(matchLiveOrPlayed
        ? {
            playerScore: (
              <BodyS as="p" bold>
                {isDnp ? (
                  <FormattedMessage
                    {...playerGameStatusLabels.did_not_play_short}
                  />
                ) : (
                  <FormattedNumber
                    value={Math.floor(computedGameScore?.score || 0)}
                    maximumFractionDigits={0}
                  />
                )}
              </BodyS>
            ),
          }
        : {}),
      onClick:
        matchLiveOrPlayed && playerGameScore
          ? () => {
              onClick?.(playerGameScore.id);
            }
          : undefined,
    };
  },
  {
    anyPlayerGameStats: gql`
      fragment anyPlayerGameStatsToGenericGame_anyPlayerGameStats on AnyPlayerGameStatsInterface {
        id
        playerGameScore {
          id
          score
          scoreStatus
        }
        anyGame {
          id
          statusTyped
          ...anyGameToGenericGame_anyGameInterface
        }
      }
      ${anyGameToGenericGame.fragments.anyGameInterface}
    ` as TypedDocumentNode<anyPlayerGameStatsToGenericGame_anyPlayerGameStats>,
  }
);
